import { AstroidProductPresentationDto } from './dto/astroidProductPresentationDto';
import { CrudServiceBase } from '../base/crudServiceBase';
import Endpoint from '../endpoint';
import { httpApi } from '../httpService';

export class AstroidProductPresentationService extends CrudServiceBase<AstroidProductPresentationDto> {
  constructor() {
    super(Endpoint.AstroidProductPresentation);
    this.internalHttp = httpApi;
  }
}

const exportAstroidProductPresentationService: AstroidProductPresentationService = new AstroidProductPresentationService();
export default exportAstroidProductPresentationService;
